import alert from './alert';
import bookingService from './booking-service';
import { combineReducers } from 'redux';
import language from './language';
import loading from './loading';
import notification from './notification';
import user from './user';
// import airportReducer from "./airport";
import inputReducer from './input';
import stepTwoReducer from './stepTwo';
import profileReducer from './profile';
import flightReducer from './flights';
import requestToken from './requestToken';

export default combineReducers({
  user,
  alert,
  loading,
  language,
  notification,
  bookingService,
  // airportReducer,
  inputReducer,
  stepTwoReducer,
  profileReducer,
  flightReducer,
  requestToken,
});
